import { render, staticRenderFns } from "./PCTeam.vue?vue&type=template&id=87049aca&scoped=true&lang=pug&"
import script from "./PCTeam.vue?vue&type=script&lang=js&"
export * from "./PCTeam.vue?vue&type=script&lang=js&"
import style0 from "./PCTeam.vue?vue&type=style&index=0&id=87049aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87049aca",
  null
  
)

export default component.exports